import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { LanguageProvider } from "@/context/LanguageContext";
import LandingPage from "@/pages/LandingPage";
import ResultsPage from "@/pages/ResultsPage";
import DashboardPage from "@/pages/DashboardPage";
import AuthCallback from "@/pages/AuthCallback";
import SubscriptionPage from "@/pages/SubscriptionPage";
import SharedCyclePage from "@/pages/SharedCyclePage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import AdminPage from "@/pages/AdminPage";
import LeadCaptureGate from "@/components/LeadCaptureGate";

const incomingRef = new URLSearchParams(window.location.search).get("ref");
if (incomingRef && /^[\w-]{4,64}$/.test(incomingRef)) localStorage.setItem("referral_code", incomingRef);

function AppContent() {
  const location = useLocation();
  const { loading, showGate, isAuthenticated } = useAuth();

  // Check for session_id in URL (Google OAuth callback)
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  // Public routes that don't need auth gate
  const publicRoutes = ['/shared/', '/subscription', '/reset-password', '/forgot-password', '/admin'];
  const isPublicRoute = publicRoutes.some(route => location.pathname.startsWith(route));

  // Show loading while checking auth
  if (loading) {
    return (
      <div className="min-h-screen bg-[#050505] flex items-center justify-center">
        <div className="spinner" />
      </div>
    );
  }

  // Show gate only if: showGate is true AND user is not authenticated AND not on public route
  const shouldShowGate = showGate && !isAuthenticated && !isPublicRoute;

  return (
    <>
      {/* Lead Capture Gate */}
      {shouldShowGate && <LeadCaptureGate />}
      
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/results" element={<ResultsPage />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/subscription" element={<SubscriptionPage />} />
        <Route path="/subscription/success" element={<SubscriptionPage />} />
        <Route path="/subscription/cancel" element={<SubscriptionPage />} />
        <Route path="/shared/:shareToken" element={<SharedCyclePage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/forgot-password" element={<ResetPasswordPage />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <div className="App min-h-screen bg-[#050505]">
          <BrowserRouter>
            <AppContent />
          </BrowserRouter>
          <Toaster position="top-right" theme="dark" />
        </div>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
